import axios from 'axios'

export default {
  /**
   * @function getRooms - Retrieve rooms
   * @param {object} queryObject - An object describing optional queryParameters
   * @return AxiosInstance
  */
  getRooms(queryObject = {}, config = {}) {
    return axios.get('rooms', {
      params: queryObject,
      ...config,
    })
  },
  /**
   * @function getRoomsLabels - Retrieve labels for the room with the mnemo provided
   * @return AxiosInstance
   */
  getRoomLabels: function (mnemo) {
    return axios.get(`room/${mnemo}/labels`)
  },
  getRoomMetadata: function (mnemo) {
    return axios.get(`room/${mnemo}/metadata`)
  },
  /**
   * @function getRoomsLabels - Retrieve labels for this subscription
   * @return AxiosInstance
   */
  getSubscriptionLabels: function (config) {
    return axios.get('rooms/labels', config)
  },
  getMetadata: function () {
    return axios.get('rooms/metadata')
  },
  getExistingRoomMetadata: function () {
    return axios.get('rooms/metadata', { params: { filtered : true } })
  },
  getDataRoomPricing () {
    return axios.get('subscription/dataroom/pricing')
  },
  getDataRoomCustomPricing (data) {
    return axios.get('subscription/dataroom/pricing/custom', { params: data })
  },
  getLastVisitedRooms (params) {
    return axios.get('rooms/last', { params })
  },
    /**
   * @function getExistingRoomsLabels
   * Retrieve labels attached to rooms accessible by the current user
   * @return AxiosInstance
   */
  getExistingRoomsLabels() {
    return axios.get('rooms/existing-labels')
  },

}
